import { createContext, useEffect, useState } from "react";
import ProfileTable from "../../Tables/DeltaHedgeBackTest/ProfileTable/ProfileTable";
import { Button, Modal, SelectableButtons } from "src/Components";
import AddProfile from "./AddProfile";
import TimeConfigTable from "src/Tables/DeltaHedgeBackTest/TimeConfigTablee/TimeConfigTable";
import {
  IBackTestSearchParams,
  IDecileTE,
  INameIdFullName,
} from "src/Interfaces/deltaHedgeBackTest";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import {
  getDecileNos,
  getGroups,
  getMatrix,
  getProfiles,
} from "src/Requests/deltaHedgeBackTest";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { IMatrixChartResponse } from "src/Interfaces/chartInterfaces";
import TETable from "src/Tables/DeltaHedgeBackTest/TE/TETable";
import DEITable from "src/Tables/DeltaHedgeBackTest/DEI/DEITable";
import BorderTable from "src/Tables/DeltaHedgeBackTest/Border/BorderTable";
import MatrixChart from "src/Components/Charts/MatrixChart";
import BackTestChart from "./Chart";

enum ModalMode {
  AddProfile,
  ProfileTable,
  TimeConfig,
  Closed,
}

export const RefreshFlagContext = createContext({
  setRefreshFlag: (_: boolean) => {},
});

const DeltaHedgeBackTest = () => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);
  const [searchParams, setSearchParams] = useState({} as IBackTestSearchParams);
  const [groups, setGroups] = useState([] as DropdownItem[]);
  const [profiles, setProfiles] = useState([] as DropdownItem[]);
  const [matrixData, setMatrixData] = useState({
    comments: [],
    labelx: "",
    labely: "",
    squares: [],
    colCount: 8,
  } as IMatrixChartResponse);
  const [activeDecileNo, setActiveDecileNo] = useState<number | null>(null);

  const [refreshFlag, setRefreshFlag] = useState(false);
  const [decileNumbers, setDecileNumbers] = useState([] as INameIdFullName[]);
  const [borderGraphRefreshFlag, setBorderGraphRefreshFlag] = useState(false);

  useEffect(() => {
    if (refreshFlag)
      setTimeout(() => {
        setRefreshFlag(false);
      }, 300);
  }, [refreshFlag]);

  useEffect(() => {
    if (refreshFlag)
      setTimeout(() => {
        setRefreshFlag(false);
      }, 300);
  }, [borderGraphRefreshFlag]);

  useEffect(() => {
    getGroups()
      .then((groupResp) => {
        setGroups(groupResp);
        getProfiles()
          .then((resp) => {
            setProfiles(resp);

            getDecileNos()
              .then((decileResp) => {
                setDecileNumbers(decileResp);

                setSearchParams({
                  groupId: (
                    groupResp.find((g) => g.name === "وبملت")?.id || ""
                  )?.toString(),
                  profileId: resp[0].id?.toString(),
                  decileNo: decileResp[0].id,
                });
              })
              .catch(packetErrorHandler);
          })
          .catch(packetErrorHandler);
      })
      .catch(packetErrorHandler);
  }, []);

  useEffect(() => {
    if (!searchParams.groupId || !searchParams.profileId) return;
    getMatrix(
      searchParams.profileId?.toString(),
      searchParams.groupId?.toString()
    )
      .then((resp) => {
        if (resp) setMatrixData(resp);
      })
      .catch(packetErrorHandler);
  }, [searchParams]);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.AddProfile:
        return <AddProfile onClose={() => setModalMode(ModalMode.Closed)} />;

      case ModalMode.ProfileTable:
        return <ProfileTable refreshFlag={refreshFlag} />;

      case ModalMode.TimeConfig:
        return <TimeConfigTable refreshFlag={refreshFlag} />;

      default:
        return <></>;
    }
  };

  const changeHandler = (name: string, value: any) => {
    setSearchParams({ ...searchParams, [name]: value });
  };

  const onRowClick = (row: IDecileTE) => {
    setActiveDecileNo(row.decileNo);
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full px-3">
      <RefreshFlagContext.Provider value={{ setRefreshFlag }}>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            onClose={() => setModalMode(ModalMode.Closed)}
            UI={getModalUI()}
          />
        ) : (
          <></>
        )}
      </RefreshFlagContext.Provider>
      <div className="flex flex-row justify-start items-start gap-3">
        <div className="w-min">
          <Button
            text="اضافه کردن پروفایل"
            onClick={() => setModalMode(ModalMode.AddProfile)}
            variant="contained"
          />
        </div>
        <div className="w-min">
          <Button
            text="پروفایل بک تست"
            onClick={() => setModalMode(ModalMode.ProfileTable)}
            variant="contained"
          />
        </div>
        {/* <div className="w-min">
          <Button
            text="تنظیمات بک تست"
            onClick={() => setModalMode(ModalMode.TimeConfig)}
            variant="contained"
          />
        </div> */}
      </div>
      <div className="flex flex-col justify-start items-start gap-3">
        <SelectableButtons
          label="گروه"
          name="groupId"
          value={searchParams.groupId}
          onChange={changeHandler}
          options={groups}
          hideSelectAll
        />
        <SelectableButtons
          label="پروفایل"
          name="profileId"
          value={searchParams.profileId}
          onChange={changeHandler}
          options={profiles}
          hideSelectAll
        />
      </div>
      <MatrixChart data={matrixData} />
      {searchParams.groupId && searchParams.profileId ? (
        <div className="grid grid-cols-2 gap-2 w-full">
          <TETable
            searchParams={searchParams}
            onRowClick={onRowClick}
            activeRowId={activeDecileNo || undefined}
          />
          {activeDecileNo ? (
            <DEITable
              searchParams={{ ...searchParams, decileNo: activeDecileNo }}
            />
          ) : (
            <div />
          )}
          <div className="flex flex-col justify-start items-start gap-2">
            <SelectableButtons
              label="دهک DEI"
              name="decileNo"
              options={decileNumbers}
              onChange={changeHandler}
              value={searchParams.decileNo || -1}
              hideSelectAll
            />
            {searchParams.decileNo ? (
              <BorderTable
                searchParams={searchParams}
                setRefreshBorderGraph={setBorderGraphRefreshFlag}
              />
            ) : (
              <></>
            )}
          </div>
          {searchParams.decileNo ? (
            <BackTestChart
              searchParam={searchParams}
              refreshFlag={borderGraphRefreshFlag}
            />
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DeltaHedgeBackTest;
